import isUrl from "is-url";

const urlProtocolRegex = /^https?:\/\//;
export default (value) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            const hasProtocol = urlProtocolRegex.test(value);
            if (!hasProtocol) {
                return reject(new Error('URL must include http or https.'));
            }

            const isValidUrl = isUrl(value);
            if (!isValidUrl) {
                return reject(new Error('Must be a valid URL.'));
            }

            resolve(value);
        }, 250);
    });
};
